<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加新闻</el-button>
      </div>
      <!--表格数据-->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="title" label="标题" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="deatil" label="内容" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="上传时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="state" label="状态" width="75px" sortable="custom">
            <template #default="{ row }">
              <el-switch v-model="row.state" @change="editState(row)" :active-value="'0'" :inactive-value="'1'" />
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="240px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此用户吗？" @onConfirm="deleteNews(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!--编辑弹窗-->
    <el-dialog
      :title="editForm.id ? '修改新闻' : '添加新闻'"
      :visible.sync="showEdit"
      width="30%"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
        <el-form-item label="标题:" prop="title">
          <el-input v-model="editForm.title" placeholder="请输入标题" maxlength="16" show-word-limit clearable />
        </el-form-item>
        <el-form-item label="类型:" prop="type">
          <el-radio v-model="editForm.type" label="0">文字</el-radio>
          <el-radio v-model="editForm.type" label="1">图片</el-radio>
        </el-form-item>
        <el-form-item v-if="editForm.type == 0" label="内容:" prop="deatil">
          <el-input v-model="editForm.deatil" type="textarea" placeholder="请输入内容" maxlength="40" show-word-limit clearable />
        </el-form-item>
        <el-form-item v-if="editForm.type == 1" label="上传图片">
          <el-upload
            ref="upload"
            :action="$http.defaults.baseURL + '/file/getFilePath'"
            :headers="$http.defaults.headers.common"
            name="multipartFile"
            :data="{ path: 'teacherImg/' }"
            :show-file-list="false"
            :limit="1"
            :on-success="uploadSuccess"
            accept="image/png,image/jpg,image/jpeg"
          >
            <el-image v-if="newsImage" :src="newsImage" style="width: 150px" />
            <el-button v-show="!newsImage" size="small" type="primary">点击上传</el-button>
            <div v-show="!newsImage" slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="save(editForm.id)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { addNews, updateNews, updateState } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/news/getList',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        showEdit: false,
        editForm: {},
        editRules: {
          // 表单验证规则
          title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
          deatil: [{ required: true, message: '请输入内容', trigger: 'blur' }],
          type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        },
        newsImage: '', //新闻图片
      };
    },
    methods: {
      //编辑显示弹窗
      edit(row) {
        this.editForm = Object.assign({}, row);
        if (row.type == 1) {
          this.newsImage = this.editForm.deatil;
          this.editForm.deatil = '';
        } else {
          this.newsImage = '';
        }
        this.showEdit = true;
      },
      // 上传图片成功调用
      uploadSuccess(res) {
        if (res.resCode == 200) {
          this.newsImage = res.data[0].fileUrl;
        } else {
          this.$message.error(res.resMsg);
        }
      },
      //保存
      save(newsId) {
        if (this.editForm.type == 1) {
          this.editForm.deatil = this.newsImage;
        }
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (newsId == undefined) {
              //添加新闻
              addNews(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              //编辑新闻
              updateNews(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      //删除新闻
      deleteNews(row) {
        let data = new FormData();
        data.append('id', row.id);
        data.append('state', -1);
        updateState(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      //修改新闻状态
      editState(row) {
        let formData = new FormData();
        formData.append('id', row.id);
        formData.append('state', row.state);
        updateState(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '修改成功' });
            this.$refs.table.reload();
          } else {
            row.state = !row.state ? 0 : 1;
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
